import { render, staticRenderFns } from "./MessageMain.vue?vue&type=template&id=d14ab1c8&scoped=true"
import script from "./MessageMain.vue?vue&type=script&lang=ts"
export * from "./MessageMain.vue?vue&type=script&lang=ts"
import style0 from "./MessageMain.vue?vue&type=style&index=0&id=d14ab1c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d14ab1c8",
  null
  
)

export default component.exports